import React from 'react';
import {Col, Modal, Row} from "antd";
import 'antd/lib/modal/style/css';
import languages from "../../language/languages";

class SystemInformationModal extends React.Component {

  render() {
    let total=this.props.systemReport.pkiTotalLicenses;
    if(total==="0")
      total=languages[this.props.language].unlimitedLabel;
    return (
      <Modal
        visible={this.props.modalType !== null} width={500} {...this.props.modalProps}>
            <Row gutter={16}>
              <Col style={{width:'100%'}} className={'text-center'}>
                <strong>{languages[this.props.language].system_security_provider} </strong>
                <p>{this.props.systemReport.provider}</p>
                <strong>{languages[this.props.language].system_state} </strong><p>{this.props.systemReport.status}</p>
                <strong>{languages[this.props.language].system_hsm} </strong>
                <p>{this.props.systemReport.hsmInfo}</p>
                <strong>{languages[this.props.language].system_licence_used} </strong>
                <p>{this.props.systemReport.pkiUsedLicenses}
                </p>
                <strong>{languages[this.props.language].system_licence} </strong>
                <p>{total}
                </p>
                <strong>{languages[this.props.language].viewLogs} </strong><p><p className={'link'} onClick={this.props.getSystemLog}>log.txt</p></p>
              </Col>
            </Row>
      </Modal>
    )
  }

};

export default SystemInformationModal;
